import { render, staticRenderFns } from "./MediaHandler.vue?vue&type=template&id=4c7dd0aa&scoped=true&"
import script from "./MediaHandler.vue?vue&type=script&lang=js&"
export * from "./MediaHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7dd0aa",
  null
  
)

export default component.exports